export type LanguageType =
	| 'en'
	| 'en-DK'
	| 'en-EE'
	| 'en-LT'
	| 'en-LV'
	| 'en-NO'
	| 'ee'
	| 'lt'
	| 'no'
	| 'se'
	| 'fi'
	| 'lv'
	| 'dk'
	| 'ru'
	| 'ru-EE'
	| 'ru-LT'
	| 'ru-LV'

const languages = {
	ee: 'EST',
	en: 'ENG',
	se: 'SWE',
	fi: 'FIN',
	no: 'NOR',
	dk: 'DAN',
	lt: 'LIT',
	lv: 'LAT',
	ru: 'RUS',
}

const languagesForCountry: {
	[index: string]: {
		[key in LanguageType]?: string
	}
} = {
	ee: {
		ee: languages.ee,
		'ru-EE': languages.ru,
		'en-EE': languages.en,
	},
	en: {
		en: languages.en,
		ee: languages.ee,
		se: languages.se,
		fi: languages.fi,
		no: languages.no,
		dk: languages.dk,
		lt: languages.lt,
		lv: languages.lv,
		ru: languages.ru,
	},
	se: {
		se: languages.se,
		en: languages.en,
	},
	fi: {
		fi: languages.fi,
		en: languages.en,
	},
	no: {
		no: languages.no,
		'en-NO': languages.en,
	},
	dk: {
		dk: languages.dk,
		'en-DK': languages.en,
	},
	lt: {
		lt: languages.lt,
		'ru-LT': languages.ru,
		'en-LT': languages.en,
	},
	lv: {
		lv: languages.lv,
		'ru-LV': languages.ru,
		'en-LV': languages.en,
	},
}

interface IAppConfig {
	country: string

	environment: string
	certificateRequesterBaseUrl: string

	system: string

	instrumentationKey: string

	authorityBaseUrl: string

	esignBaseUrl: string

	electronicIdScriptUrl: string

	afterbanksScriptUrl: string

	customerDataBaseUrl: string

	languages: {
		[key in LanguageType]?: string
	}

	gtmId: string

	cookiebotId: string

	umbracoBaseUrl: string

	dixaMessengerToken: string

	mypagesInstance: string
}

let appConfig: IAppConfig = {
	country: process.env.REACT_APP_COUNTRY as string,

	environment: process.env.REACT_APP_ENVIRONMENT as string,

	system: process.env.REACT_APP_DESIGN_VERSION as string,

	instrumentationKey: process.env
		.REACT_APP_APPLICATION_INSIGHTS_INSTRUMENTATIONKEY as string,

	certificateRequesterBaseUrl:
		'https://esigningcertificaterequester.azurewebsites.net',

	authorityBaseUrl: process.env.REACT_APP_AUTHORITY_BASE_URL as string,

	esignBaseUrl: process.env.REACT_APP_ESIGN_BASE_URL as string,

	customerDataBaseUrl: process.env
		.REACT_APP_BASE_CUSTOMER_DATA_API_URL as string,

	electronicIdScriptUrl: process.env
		.REACT_APP_ELECTRONICID_SCRIPT_URL as string,

	afterbanksScriptUrl: process.env.REACT_APP_AFTERBANKS_SCRIPT_URL as string,

	languages: languagesForCountry[process.env.REACT_APP_COUNTRY as string],

	gtmId: process.env.REACT_APP_GTMID as string,

	cookiebotId: process.env.REACT_APP_COOKIEBOT_ID as string,

	umbracoBaseUrl: process.env.REACT_APP_UMBRACO_BASE_URL as string,

	dixaMessengerToken: process.env.REACT_APP_DIXA_MESSENGER_TOKEN as string,

	mypagesInstance: 'tfbank',
}

export default appConfig
